/* Appends the bundle price to the add-to-cart label ("Add to cart · £X"), matching the main PDP.
   Variant-reactive: re-applies on variant:changed (Hyper swaps the submit button then, wiping the
   suffix) and reads the selected variant's price. Idempotent via a stored base label; FoxTheme.Currency
   can load late, hence the frame-capped retry. */
if (!customElements.get('bundle-atc')) {
  class BundleAtc extends HTMLElement {
    connectedCallback() {
      this.moneyFormat = this.dataset.moneyFormat || '';
      this._onVariantChange = this._onVariantChange.bind(this);
      this.apply(parseInt(this.dataset.price, 10));
      document.addEventListener('variant:changed', this._onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this._onVariantChange);
    }

    _onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (variant && typeof variant.price === 'number') this.apply(variant.price);
    }

    apply(price, attempt = 0) {
      if (isNaN(price)) return;
      const scope = this.closest('[id^="shopify-section-"]') || document;
      const textEl = scope.querySelector('.product-form__submit .btn__text');
      if (!textEl) return;
      const money =
        window.FoxTheme && FoxTheme.Currency ? FoxTheme.Currency.formatMoney(price, this.moneyFormat) : '';
      if (!money && attempt < 200) {
        requestAnimationFrame(() => this.apply(price, attempt + 1));
        return;
      }
      if (!money) return;
      // Base label is captured once per button; on a fresh (theme-swapped) button it re-captures.
      const base = textEl.dataset.bundleBase || textEl.textContent.trim();
      textEl.dataset.bundleBase = base;
      textEl.textContent = base + ' · ' + money;
    }
  }
  customElements.define('bundle-atc', BundleAtc);
}
